import { render } from "./getPriceTruckInventory.vue?vue&type=template&id=793fc960&scoped=true"
import script from "./getPriceTruckInventory.vue?vue&type=script&lang=js"
export * from "./getPriceTruckInventory.vue?vue&type=script&lang=js"

import "./getPriceTruckInventory.vue?vue&type=style&index=0&id=793fc960&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793fc960"]])

export default __exports__